import {StyleSheet} from "aphrodite-jss"

export const styles = StyleSheet.create({
    container : {
        height: "wrap-content",
        minHeight: "200px",
        width: "700px",
        backgroundColor: "white",
        padding: "10px",
    },
    content: {
        display: "flex",
        flexDirection: "column"
    },
    name: {
        fontSize: "24px",
        fontWeight: "bold",
        marginLeft: "auto",
        marginRight: "auto",
    },
    description: {
        marginTop: "10px",
        textAlign: "center"
    },
});


// WEBPACK FOOTER //
// ./src/components/dialogs/SubjectAreaDetailDialogStyles.ts